var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "svg",
    {
      attrs: {
        width: "88",
        height: "88",
        viewBox: "0 0 88 88",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { opacity: "0.5" } }, [
        !_vm.isScaling
          ? _c("path", {
              attrs: {
                d: "M84.0414 42.4961L80.292 39.3395C79.763 38.8941 78.9631 39.0143 78.5884 39.5955L78.4547 39.8027C78.1839 40.2227 78.216 40.7696 78.534 41.1551L79.7266 42.6004C80.0661 43.012 80.0773 43.6032 79.7535 44.0273L78.6922 45.4175C78.3983 45.8024 78.3777 46.3303 78.6406 46.7369L79.011 47.31C79.4072 47.9229 80.2674 48.0151 80.7845 47.5002L84.112 44.1873C84.5893 43.7121 84.5566 42.9299 84.0414 42.4961Z",
                fill: "white",
              },
            })
          : _vm._e(),
        !_vm.isScaling
          ? _c("path", {
              attrs: {
                d: "M2.95863 44.5039L6.70803 47.6605C7.23704 48.1059 8.03687 47.9857 8.41164 47.4045L8.54528 47.1973C8.81609 46.7773 8.78403 46.2304 8.466 45.8449L7.27343 44.3995C6.93389 43.988 6.92272 43.3968 7.24647 42.9727L8.30785 41.5825C8.6017 41.1976 8.62235 40.6697 8.35944 40.2631L7.98897 39.69C7.59276 39.0771 6.73265 38.9849 6.21547 39.4998L2.88803 42.8127C2.41072 43.2879 2.44337 44.0701 2.95863 44.5039Z",
                fill: "white",
              },
            })
          : _vm._e(),
        !_vm.isScaling
          ? _c("path", {
              attrs: {
                d: "M44.5039 84.0414L47.6605 80.292C48.1059 79.763 47.9857 78.9631 47.4045 78.5884L47.1973 78.4547C46.7773 78.1839 46.2304 78.216 45.8449 78.534L44.3996 79.7266C43.988 80.0661 43.3968 80.0773 42.9727 79.7535L41.5825 78.6922C41.1976 78.3983 40.6697 78.3777 40.2631 78.6406L39.69 79.011C39.0771 79.4072 38.9849 80.2674 39.4998 80.7845L42.8127 84.112C43.2879 84.5893 44.0701 84.5566 44.5039 84.0414Z",
                fill: "white",
              },
            })
          : _vm._e(),
        !_vm.isScaling
          ? _c("path", {
              attrs: {
                d: "M42.4961 2.95863L39.3395 6.70803C38.8941 7.23704 39.0143 8.03687 39.5955 8.41164L39.8027 8.54528C40.2227 8.81609 40.7696 8.78403 41.1551 8.466L42.6004 7.27343C43.012 6.93389 43.6032 6.92272 44.0273 7.24647L45.4175 8.30785C45.8024 8.6017 46.3303 8.62235 46.7369 8.35944L47.31 7.98897C47.9229 7.59276 48.0151 6.73265 47.5002 6.21547L44.1873 2.88803C43.7121 2.41072 42.9299 2.44337 42.4961 2.95863Z",
                fill: "white",
              },
            })
          : _vm._e(),
      ]),
      _c("g", { attrs: { filter: "url(#filter0_d_927_50965)" } }, [
        _c("circle", {
          attrs: {
            cx: "43.5",
            cy: "43.5",
            r: "30.5",
            fill: "white",
            "fill-opacity": "0.25",
            "shape-rendering": "crispEdges",
          },
        }),
      ]),
      _c("g", { attrs: { filter: "url(#filter1_d_927_50965)" } }, [
        _c("circle", {
          attrs: {
            cx: "43.5",
            cy: "43.5",
            r: "23.5",
            fill: "url(#paint0_linear_927_50965)",
            stroke: "black",
            "stroke-width": "2",
          },
        }),
        _c("circle", {
          attrs: {
            cx: "43.4999",
            cy: "43.4999",
            r: "19.9286",
            fill: "#62D43F",
          },
        }),
      ]),
      _c(
        "defs",
        [
          _c(
            "filter",
            {
              attrs: {
                id: "filter0_d_927_50965",
                x: "9",
                y: "12",
                width: "69",
                height: "69",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feColorMatrix", {
                attrs: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha",
                },
              }),
              _c("feOffset", { attrs: { dy: "3" } }),
              _c("feGaussianBlur", { attrs: { stdDeviation: "2" } }),
              _c("feComposite", {
                attrs: { in2: "hardAlpha", operator: "out" },
              }),
              _c("feColorMatrix", {
                attrs: {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0",
                },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_927_50965",
                },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_927_50965",
                  result: "shape",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter1_d_927_50965",
                x: "19",
                y: "19",
                width: "49",
                height: "51",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feColorMatrix", {
                attrs: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha",
                },
              }),
              _c("feOffset", { attrs: { dy: "2" } }),
              _c("feComposite", {
                attrs: { in2: "hardAlpha", operator: "out" },
              }),
              _c("feColorMatrix", {
                attrs: {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
                },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_927_50965",
                },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_927_50965",
                  result: "shape",
                },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_927_50965",
                x1: "43.5",
                y1: "21",
                x2: "43.5",
                y2: "66",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#B8F5A5" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#347321" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }